export default {
  common: {
    back: 'Back',
    contact: 'Contact',
    email: 'support@wedora.fr',
    privacyEmail: 'privacy@wedora.fr',
  },
  termsOfService: {
    title: 'Terms of Service',
    sections: {
      introduction: {
        title: '1. Introduction',
        content: 'Welcome to Wedora. By using our service, you agree to comply with these terms of service. Please read them carefully before using our platform.',
      },
      description: {
        title: '2. Service Description',
        content: 'Wedora is a wedding planning platform that allows couples to:',
        features: [
          'Manage their guest list',
          'Track their budget',
          'Organize their tasks',
          'Create their wedding website',
          'Communicate with their vendors',
        ],
      },
      accounts: {
        title: '3. User Accounts',
        content: 'To use Wedora, you must create an account. You are responsible for maintaining the confidentiality of your credentials and all activities that occur under your account.',
      },
      usage: {
        title: '4. Service Usage',
        content: 'By using our service, you agree to:',
        rules: [
          'Not use the service for illegal purposes',
          'Not attempt to compromise the security of the service',
          'Not share inappropriate or offensive content',
          'Respect the rights of other users',
        ],
      },
      intellectual: {
        title: '5. Intellectual Property',
        content: 'All content on Wedora, including but not limited to texts, graphics, logos, and source code, is the property of Wedora or its partners and is protected by intellectual property laws.',
      },
      modifications: {
        title: '6. Terms Modifications',
        content: 'We reserve the right to modify these terms at any time. Modifications will take effect upon publication on the site. Your continued use of the service after these modifications constitutes your acceptance of the new terms.',
      },
      contact: {
        title: '7. Contact',
        content: 'For any questions regarding these terms of service, please contact us at: support@wedora.fr',
      },
    },
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    sections: {
      introduction: {
        title: '1. Introduction',
        content: 'At Wedora, we place great importance on protecting your personal data. This privacy policy explains how we collect, use and protect your information.',
      },
      dataCollection: {
        title: '2. Data Collection',
        content: 'We collect the following information:',
        types: [
          'Profile information (name, first name, email)',
          'Information about your wedding (date, location)',
          'Guest list',
          'Budget information',
          'Customization preferences',
        ],
      },
      dataUsage: {
        title: '3. Data Usage',
        content: 'We use your data to:',
        purposes: [
          'Provide and improve our services',
          'Personalize your experience',
          'Communicate with you regarding your account',
          'Send important notifications',
          'Analyze and improve our services',
        ],
      },
      dataProtection: {
        title: '4. Data Protection',
        content: 'We implement appropriate security measures to protect your data against any unauthorized access, modification, disclosure or destruction. Your data is stored on secure servers and is encrypted during transmission.',
      },
      dataSharing: {
        title: '5. Data Sharing',
        content: 'We never sell your personal data to third parties. We may share certain information with our service providers who help us operate our platform, subject to strict confidentiality obligations.',
      },
      rights: {
        title: '6. Your Rights',
        content: 'In accordance with GDPR, you have the following rights:',
        list: [
          'Right of access to your data',
          'Right of rectification',
          'Right to erasure',
          'Right to data portability',
          'Right to object to processing',
        ],
      },
      cookies: {
        title: '7. Cookies',
        content: 'We use cookies to improve your experience on our platform. You can control the use of cookies through your browser settings.',
      },
      contact: {
        title: '8. Contact',
        content: 'For any questions regarding our privacy policy or to exercise your rights, please contact us at: privacy@wedora.fr',
      },
    },
  },
}; 